/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BuscaRouteImport } from './routes/busca'
import { Route as CarrinhoRouteImport } from './routes/carrinho'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as ContaRouteImport } from './routes/conta'
import { Route as EntrarRouteImport } from './routes/entrar'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as PedidosIndexRouteImport } from './routes/pedidos.index'
import { Route as PedidosIdRouteImport } from './routes/pedidos.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BuscaRoute = BuscaRouteImport.update({
  id: '/busca',
  path: '/busca',
  getParentRoute: () => rootRouteImport,
} as any)
const CarrinhoRoute = CarrinhoRouteImport.update({
  id: '/carrinho',
  path: '/carrinho',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const ContaRoute = ContaRouteImport.update({
  id: '/conta',
  path: '/conta',
  getParentRoute: () => rootRouteImport,
} as any)
const EntrarRoute = EntrarRouteImport.update({
  id: '/entrar',
  path: '/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const PSlugRoute = PSlugRouteImport.update({
  id: '/p/$slug',
  path: '/p/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PedidosIndexRoute = PedidosIndexRouteImport.update({
  id: '/pedidos/',
  path: '/pedidos/',
  getParentRoute: () => rootRouteImport,
} as any)
const PedidosIdRoute = PedidosIdRouteImport.update({
  id: '/pedidos/$id',
  path: '/pedidos/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/busca': typeof BuscaRoute
  '/carrinho': typeof CarrinhoRoute
  '/checkout': typeof CheckoutRoute
  '/conta': typeof ContaRoute
  '/entrar': typeof EntrarRoute
  '/p/$slug': typeof PSlugRoute
  '/pedidos/$id': typeof PedidosIdRoute
  '/pedidos/': typeof PedidosIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/busca': typeof BuscaRoute
  '/carrinho': typeof CarrinhoRoute
  '/checkout': typeof CheckoutRoute
  '/conta': typeof ContaRoute
  '/entrar': typeof EntrarRoute
  '/p/$slug': typeof PSlugRoute
  '/pedidos/$id': typeof PedidosIdRoute
  '/pedidos': typeof PedidosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/busca': typeof BuscaRoute
  '/carrinho': typeof CarrinhoRoute
  '/checkout': typeof CheckoutRoute
  '/conta': typeof ContaRoute
  '/entrar': typeof EntrarRoute
  '/p/$slug': typeof PSlugRoute
  '/pedidos/$id': typeof PedidosIdRoute
  '/pedidos/': typeof PedidosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/busca'
    | '/carrinho'
    | '/checkout'
    | '/conta'
    | '/entrar'
    | '/p/$slug'
    | '/pedidos/$id'
    | '/pedidos/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/busca'
    | '/carrinho'
    | '/checkout'
    | '/conta'
    | '/entrar'
    | '/p/$slug'
    | '/pedidos/$id'
    | '/pedidos'
  id:
    | '__root__'
    | '/'
    | '/busca'
    | '/carrinho'
    | '/checkout'
    | '/conta'
    | '/entrar'
    | '/p/$slug'
    | '/pedidos/$id'
    | '/pedidos/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BuscaRoute: typeof BuscaRoute
  CarrinhoRoute: typeof CarrinhoRoute
  CheckoutRoute: typeof CheckoutRoute
  ContaRoute: typeof ContaRoute
  EntrarRoute: typeof EntrarRoute
  PSlugRoute: typeof PSlugRoute
  PedidosIdRoute: typeof PedidosIdRoute
  PedidosIndexRoute: typeof PedidosIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/busca': {
      id: '/busca'
      path: '/busca'
      fullPath: '/busca'
      preLoaderRoute: typeof BuscaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/carrinho': {
      id: '/carrinho'
      path: '/carrinho'
      fullPath: '/carrinho'
      preLoaderRoute: typeof CarrinhoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conta': {
      id: '/conta'
      path: '/conta'
      fullPath: '/conta'
      preLoaderRoute: typeof ContaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entrar': {
      id: '/entrar'
      path: '/entrar'
      fullPath: '/entrar'
      preLoaderRoute: typeof EntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$slug': {
      id: '/p/$slug'
      path: '/p/$slug'
      fullPath: '/p/$slug'
      preLoaderRoute: typeof PSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pedidos/': {
      id: '/pedidos/'
      path: '/pedidos'
      fullPath: '/pedidos/'
      preLoaderRoute: typeof PedidosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pedidos/$id': {
      id: '/pedidos/$id'
      path: '/pedidos/$id'
      fullPath: '/pedidos/$id'
      preLoaderRoute: typeof PedidosIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BuscaRoute: BuscaRoute,
  CarrinhoRoute: CarrinhoRoute,
  CheckoutRoute: CheckoutRoute,
  ContaRoute: ContaRoute,
  EntrarRoute: EntrarRoute,
  PSlugRoute: PSlugRoute,
  PedidosIdRoute: PedidosIdRoute,
  PedidosIndexRoute: PedidosIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
